interface NavAttributes {
  [propName: string]: any;
}

interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}

interface NavBadge {
  text: string;
  variant: string;
}

interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  key?: string;
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
  system?: boolean;
}

export const navItems: NavData[] = [
  {
    key: 'DASHBOARD',
    name: 'Panel Control',
    url: '/dashboard',
    icon: 'icon-speedometer',
    attributes: { system: false }
  },
  {
    key: 'SYSTEM',
    title: true,
    name: 'Sistema',
    attributes: { system: true }
  },
  {
    key: 'ORGANIZATION',
    name: 'Organización',
    url: '/system/organization',
    icon: 'icon-organization',
    attributes: { system: true }
  },
  {
    key: 'USER',
    name: 'Usuarios',
    url: '/system/customers',
    icon: 'icon-people',
    attributes: { system: true }
  },
  // {
  //   key: 'AUDIT',
  //   name: 'Auditoría',
  //   url: '/system/audits',
  //   icon: 'icon-eye',
  //   attributes: { system: false }
  // },
  {
    key: 'MASTER',
    title: true,
    name: 'Maestros',
    attributes: { system: false }
  },
  {
    key: 'MACHINE',
    name: 'Máquinas',
    url: '/master/machines',
    icon: 'icon-social-steam',
    attributes: { system: false }
  },
  {
    key: 'DEVICES',
    name: 'Dispositivos',
    url: '/master/devices',
    icon: 'icon-layers',
    attributes: { system: false }
  },
  {
    key: 'WELD',
    title: true,
    name: 'Registros',
    attributes: { system: false }
  },
  // {
  //   key: 'WELD_REGISTER',
  //   name: 'Registros Soldadura',
  //   url: '/weld/weld-registers',
  //   icon: 'icon-wrench',
  //   attributes: { system: false }
  // },
  {
    key: 'GRAPH_DEVICE',
    name: 'Gráfica Dispositivos',
    url: '/weld/graph-device',
    icon: 'icon-chart',
    attributes: { system: false }
  },
  {
    key: 'WELD_MESSAGE',
    name: 'Registros Soldadura',
    url: '/weld/weld-messages',
    icon: 'icon-user',
    attributes: { system: false }
  },
  // {
  //   key: 'WELD_SESSIONS',
  //   name: 'Registros de sesiones',
  //   url: '/weld/session',
  //   icon: 'icon-screen-desktop',
  //   attributes: { system: false }
  // },
  {
    key: 'CHAT_IA',
    name: 'Chat IA',
    url: '/weld/ia',
    icon: 'icon-bubbles',
    attributes: { system: false }
  },
  {
    key: 'THINGTRACK',
    name: 'Ir a Thingtrack',
    url: 'http://www.thingtrack.com',
    icon: 'icon-cloud-download',
    class: 'mt-auto',
    variant: 'success',
    attributes: { target: '_blank', rel: 'noopener', system: false }
  }
];
